module.exports = __webpack_public_path__ + "static/media/bannerL.a7f37a55.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/bannerL.jpg
// module id = 289
// module chunks = 0